import {
    ACTIVATE_ITEM,
    HIDE_CHILD,
    SHOW_CHILD,
    RESET_STATE,
} from '@eb/eds-hot-keys';

// See https://craig.is/killing/mice for available patterns of declaring keyboard sequences.
export const ACTION_KEY_MAP = {
    // action(str) : keyCombination
    [RESET_STATE]: ['tab', 'shift+tab'],
    [HIDE_CHILD]: 'esc',
    [SHOW_CHILD]: 'down',
    [ACTIVATE_ITEM]: 'enter',
};
